module.exports = __webpack_public_path__ + "static/media/golfer-4-b.e5e92eb0.png";